/* eslint-disable no-unused-expressions */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Container, DialogContent, StyledCreateUpdateForm } from './styles';
import restApiClient from '../../services/restApiClient';

function HolidayDialog({
  onSuccess,
  onError,
  onCancel,
  holiday,
  calendarId,
  ...props
}) {
  return (
    <Container>
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        {...props}
      >
        <DialogContent>
          <StyledCreateUpdateForm
            modelSchema={holiday}
            restGetDataById={restApiClient.holiday.findById}
            restCreateData={restApiClient.holiday.create}
            onCreateSuccess={(request) => {
              onSuccess?.(request);
            }}
            onCancelClick={onCancel}
            modelData={{ ...holiday.data, calendarId: calendarId }}
            {...props}
          />
        </DialogContent>
      </Dialog>
    </Container>
  );
}

export default HolidayDialog;
